// extracted by mini-css-extract-plugin
export default {"main_container":"style_main_container__n4MCP","header":"style_header__uaUH0","tv_show_detail":"style_tv_show_detail__KIn7f","recommandations":"style_recommandations__3vqF3"};